export default defineNuxtPlugin(async () => {
  const router = useRouter()
  const mainStore = useMainStore()

  router?.afterEach((to, from) => {
    mainStore.setPrevRoute(from)
  })
})
